var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.params.subid && this.params.programname !== 'latihan')?_c('div',[_c('list-tryout-question')],1):(
      _vm.params.subid &&
        _vm.params.programname == 'latihan' &&
        _vm.params.subname == 'kecermatan'
    )?_c('div',[_c('list-tryout-kecermatan')],1):_c('div',[_c('list-questions')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }